import React, { useContext, useState } from 'react';
import {
  ButtonDropdown,
  DropdownToggle,
  DropdownMenu,
  DropdownItem,
} from 'reactstrap';
import { toAccountSettings, toSignOut } from '../../routes';
import { Link } from 'gatsby';
import {
  UserContext,
  UserContextType,
  isEmployerType,
  isStaffType,
} from '../../context/UserContext';
import ProfilePicture from '../common/ProfilePicture';

const AuthenticatedDropdownMenu = () => {
  const { user } = useContext(UserContext) as UserContextType;
  const [userMenuIsOpen, setUserMenuIsOpen] = useState(false);

  const name = isStaffType(user)
    ? `${user?.firstName} ${user?.lastName}`
    : user?.name;

  function toggleUserMenu() {
    setUserMenuIsOpen(!userMenuIsOpen);
  }

  return (
    <ButtonDropdown isOpen={userMenuIsOpen} toggle={toggleUserMenu}>
      <DropdownToggle
        color="link"
        caret
        className="d-flex align-items-center text-black"
      >
        <div style={{ width: '55px', height: '55px' }} className="me-2">
          <ProfilePicture
            photoUrl={user?.photoThumbnailUrl}
            alt={name}
            squarePhoto={isEmployerType(user)}
            resumePreview={!user}
          />
        </div>
        <span
          className="text-truncate d-none d-md-inline-block"
          style={{ maxWidth: '150px' }}
          title={name}
        >
          {name}
        </span>
      </DropdownToggle>
      <DropdownMenu className="w-100">
        {!!user && (
          <>
            <DropdownItem tag={Link} to={toAccountSettings}>
              Settings
            </DropdownItem>
            <DropdownItem divider />
          </>
        )}
        <DropdownItem tag={Link} to={toSignOut}>
          Sign Out
        </DropdownItem>
      </DropdownMenu>
    </ButtonDropdown>
  );
};

export default AuthenticatedDropdownMenu;
